/* eslint-disable @typescript-eslint/return-await */
import { AxiosResponse } from "axios";
import API from "../api";
import { Group } from "../models/group";
import { MemberInGroup } from "Models/memberInGroup";

const ROUTE_NAME = "groups";

const GroupService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },

  async getById(id: number, options?: any): Promise<AxiosResponse<Group> | null> {
    if (!id) return null;

    return await API.get(`/${ROUTE_NAME}/get/${id}`, { params: options });
  },

  async getGroups(options?: any): Promise<AxiosResponse<Group[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },

  async getAll(options?: any): Promise<AxiosResponse<Group[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },

  async getUsersInGroup(options?: any): Promise<AxiosResponse<MemberInGroup[]>> {
    return await API.get(`/group-users/users-by-group`, { params: options });
  },

  async getAccessRules(options?: any): Promise<AxiosResponse<Group[]>> {
    return await API.get(`/access-rules`, { params: options });
  },

  async createGroup(group: Group): Promise<AxiosResponse<Group>> {
    return await API.post(`/${ROUTE_NAME}`, group);
  },

  async updateGroup(id?: number, group?: Group): Promise<AxiosResponse<Group>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, group);
  },

  async deleteGroup(id: number): Promise<AxiosResponse<Group>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default GroupService;
